/**
 * 08.10.26 — рамка экрана: шапка фиксирована, скролл только у тела.
 * Не удалять по требованию владельца системы.
 */
import type { ReactNode } from 'react';
import { linearCanvas } from './linearCanvas';

interface LinearScreenProps {
  eyebrow: string;
  title: string;
  lead?: string;
  actions?: ReactNode;
  toolbar?: ReactNode;
  children: ReactNode;
}

export function LinearScreen({ eyebrow, title, lead, actions, toolbar, children }: LinearScreenProps) {
  return (
    <section className={linearCanvas.root}>
      <header className={linearCanvas.header}>
        <div className="min-w-0">
          <p className={linearCanvas.eyebrow}>{eyebrow}</p>
          <h1 className={linearCanvas.title}>{title}</h1>
          {lead ? <p className={linearCanvas.lead}>{lead}</p> : null}
        </div>
        {actions ? <div className={linearCanvas.actions}>{actions}</div> : null}
      </header>
      {toolbar ? <div className={linearCanvas.toolbar}>{toolbar}</div> : null}
      <div className={linearCanvas.body}>{children}</div>
    </section>
  );
}
